
<div class="row card_layout client-todos px-0" *ngIf="showTable" [ngClass]="{ 'customer-todos': isCustomer }">
   <div class="column medium-8 large-9 small-12" *ngIf="type !== 'singlePage' && type !== 'tracker-singlePage' && !isClientInfo">
            <div class="page-title">All Plans ToDo’s</div>
        </div>
  <div class="column medium-4 large-3 small-12" *ngIf="type !== 'singlePage' && type !== 'tracker-singlePage' && !isClientInfo">
            <select class="dropdown" [(ngModel)]="selectedPlanId" (ngModelChange)="onPlanSelect($event)">
                <option [value]="'all'">All Plans</option>
              <option *ngFor="let plan of clientPlanOptions" [value]="plan.id">{{ plan.planName }}</option>
            </select>
        </div>
  <div class="column medium-12 wall-documents-view" *ngIf="type !== 'singlePage' && type !== 'tracker-singlePage' && !isClientInfo">
    <div *ngIf="todoStatus == 'Assigned'">
      <span><button class="button small primary-button">Assigned</button></span>
      <span><button class="button small secondary-button" (click)="showTodos('Done')">Done</button></span>
    </div>
    <div *ngIf="todoStatus == 'Done'">
      <span><button class="button small primary-button" (click)="showTodos('Assigned')">Assigned</button></span>
      <span><button class="button small secondary-button">Done</button></span>
    </div>
  </div>
  <div class="column medium-12 medcillary">
    <div class="add-share-buttons" style="z-index: 999;padding-left: 0.9375rem;padding-right: 0.9375rem;margin-bottom: 5px;">

      <div class="float-left text-left todo-head" *ngIf="isClientInfo">ToDo's</div>
      <div class="pointer float-right text-right" (click)="addTodo()" *ngIf="type !== 'all' && type !== 'singlePage' && type !== 'tracker-singlePage'"><i class="material-icons" style="padding-right: 2px">add_circle</i></div>
      <div class="float-right" style="bottom: 2px;position: relative;">
        <common-search></common-search>
      </div>
      <div class="clear"></div>
    </div>
  </div>
  <div class="column medium-12 indy-tables badge-tables client-todo-table zero-padding tracker-singlePage" *ngIf="type == 'tracker-singlePage'">
    <app-tracker-paginated-table [setObj]="tableData" *ngIf="hasToDos" (onRowAction)="handleAction($event)" (onSort)="sortByColumn($event)"
                             (onInputBlur)="updateInput($event)" (onScroll)="handleScroll($event)" (onStatusMove)="moveNextStatus($event)"></app-tracker-paginated-table>
  </div>
  <div class="column medium-12 indy-tables badge-tables client-todo-table zero-padding" [ngClass]="type == 'singlePage'? 'show-desc': ''" *ngIf="type != 'tracker-singlePage'">
    <app-tracker-paginated-table [setObj]="tableData" *ngIf="hasToDos" (onRowAction)="handleAction($event)" (onSort)="sortByColumn($event)"
                             (onScroll)="handleScroll($event)" (onStatusMove)="moveNextStatus($event)" (onInputSearchSelection)="optionSelected($event)"></app-tracker-paginated-table>
  </div>
  <div class="collaboration column medium-12" *ngIf="type == 'singlePage' && showPost && currentTodo && !currentTodo.postId">
    <app-new-post [companyId]="currentTodo.companyId" [pageType]="'companies'" [labelTypes]="[]"
                  [externalUsers]="[]" [posts]="[]" [entityType]="'todo'" [entityId]="currentTodo.id"
                  (onPostCreation)="createdPost($event)">
    </app-new-post>
  </div>
  <div class="collaboration column medium-12">
    <post-wall [post]="currentPost" *ngIf="type == 'singlePage' && showPost && currentTodo && currentTodo.postId" [companyId]="currentTodo.companyId" [pageType]="'companies'" [labelTypes]="[]"></post-wall>
  </div>
</div>
